<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-subtitle>Filtri primari</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div
            *ngFor="let filter of primaryFilters; trackBy: trackBy"
            class="se-menu-item se-menu-button se-settings-item-container"
            [class.selected]="filter.property.name === selected"
            [@movingUpAnimation]="(movingUp$ | async) === filter.property.name"
            (@movingUpAnimation.done)="onMovingUpAnimationEnd($event)"
            [@movedUpAnimation]="(movedUp$ | async) === filter.property.name"
            (@movedUpAnimation.done)="onMovedUpAnimationEnd($event)"
            [@movingDownAnimation]="(movingDown$ | async) === filter.property.name"
            (@movingDownAnimation.done)="onMovingDownAnimationEnd($event)"
            [@movedDownAnimation]="(movedDown$ | async) === filter.property.name"
            (@movedDownAnimation.done)="onMovedDownAnimationEnd($event)"
            [@leavingLeftAnimation]="(leavingLeft$ | async) === filter.property.name"
            (@leavingLeftAnimation.done)="onPrimaryFilterLeft($event)"
            [@enteringLeftAnimation]="(enteringLeft$ | async) === filter.property.name"
            (@enteringLeftAnimation.done)="onFilterEntered($event)"
            (click)="select(filter)"
        >
            <span class="settings-key">{{ labelTranslationKeyToString(filter.labelTranslationKey) | translate }}</span>
            <div class="settings-entries">
                <div class="settings-entry-container">
                    <mat-slide-toggle
                        [disabled]="!primaryChangesAllow(filter) || !!primaryChangingFilter"
                        [checked]="filter.layout?.row === 0"
                        (change)="primaryChanged($event, filter)"
                        >{{ "IsPrimary" | translate }}
                    </mat-slide-toggle>
                </div>
                <div class="settings-entry-container">
                    <div class="settings-position-button-group">
                        <button
                            aria-label="move element upward"
                            class="setting-position-button"
                            (click)="moveUp(filter, true)"
                            [disabled]="!movePrevAllow(filter)"
                        >
                            <mat-icon>arrow_upward</mat-icon>
                        </button>
                        <button
                            aria-label="move element downward"
                            class="setting-position-button"
                            (click)="moveDown(filter, true)"
                            [disabled]="!moveNextAllow(filter, true)"
                        >
                            <mat-icon>arrow_downward</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-subtitle>Filtri secondari</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div
            *ngFor="let filter of secondaryFilters; trackBy: trackBy"
            class="se-menu-item se-menu-button se-settings-item-container"
            [class.selected]="filter.property.name === selected"
            [@movingUpAnimation]="(movingUp$ | async) === filter.property.name"
            (@movingUpAnimation.done)="onMovingUpAnimationEnd($event)"
            [@movedUpAnimation]="(movedUp$ | async) === filter.property.name"
            (@movedUpAnimation.done)="onMovedUpAnimationEnd($event)"
            [@movingDownAnimation]="(movingDown$ | async) === filter.property.name"
            (@movingDownAnimation.done)="onMovingDownAnimationEnd($event)"
            [@movedDownAnimation]="(movedDown$ | async) === filter.property.name"
            (@movedDownAnimation.done)="onMovedDownAnimationEnd($event)"
            [@leavingRightAnimation]="(leavingRight$ | async) === filter.property.name"
            (@leavingRightAnimation.done)="onSecondaryFilterLeft($event)"
            [@enteringRightAnimation]="(enteringRight$ | async) === filter.property.name"
            (@enteringRightAnimation.done)="onFilterEntered($event)"
            (click)="select(filter)"
        >
            <span class="settings-key">{{ labelTranslationKeyToString(filter.labelTranslationKey) | translate }}</span>
            <div class="settings-entries">
                <div class="settings-entry-container">
                    <mat-slide-toggle
                        [disabled]="!primaryChangesAllow(filter) || !!primaryChangingFilter"
                        [checked]="filter.layout?.row === 0"
                        (change)="primaryChanged($event, filter)"
                        >{{ "IsPrimary" | translate }}
                    </mat-slide-toggle>
                </div>
                <div class="settings-entry-container">
                    <div class="settings-position-button-group">
                        <button
                            aria-label="move element upward"
                            class="setting-position-button"
                            (click)="moveUp(filter, false)"
                            [disabled]="!movePrevAllow(filter)"
                        >
                            <mat-icon>arrow_upward</mat-icon>
                        </button>
                        <button
                            aria-label="move element downward"
                            class="setting-position-button"
                            (click)="moveDown(filter, false)"
                            [disabled]="!moveNextAllow(filter)"
                        >
                            <mat-icon>arrow_downward</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
